import axios from "axios";
import { obtainEnvironment } from "../config/utils/enviroment";

export const apiClient = axios.create({
  baseURL: obtainEnvironment(import.meta.env.VITE_ENTORNO),
});
